import {
  AppContext,
  Clients,
  Close,
  Project,
  Ticket,
  Reports,
  Charts,
  isAuthorised,
  Script,
  Invoice,
  ItDocumantation,
  ContractTemplate,
  ALL_MODULES,
  TAB_PAGES,
  ModuleLogo,
  getTranslatedText
} from '@nile/components';
import { HomeContext } from '@nile/mangifera/src/Contexts';
import TabContext from '@nile/mangifera/src/Contexts/TicketContext';
import { Module } from '@nile/mangifera/src/Pebbles/AppHomePage';
import { getTabTemplate } from '@nile/mangifera/src/Pebbles/TabManager';
import { Button } from '@superops/ui-design-system';
import { cloneDeep } from 'lodash';
import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import { FormattedMessage, useIntl, injectIntl } from 'react-intl';

function GlobalCreatePage(props) {
  const { flags } = props;
  const intl = useIntl();
  const appContext = useContext(AppContext);
  const homeContext = useContext(HomeContext);
  const tabContext = useContext(TabContext);
  const { user } = appContext;
  const browser = homeContext.getBrowserType();
  const handleCreation = (mod) => {
    const currentAppState = homeContext?.userAppState || { appState: [] };
    const updatedAppState = cloneDeep(currentAppState.appState);
    let tab = null;
    switch (mod.name) {
      case 'TICKET':
        tab = updatedAppState.find((el) => el.id === 'new-tab');
        if (!tab) {
          tab = {
            id: 'new-tab',
            content: getTabTemplate({ module: 'NEW' }),
            module: 'NEW',
            tabId: 'new-tab',
            state: {},
            data: {},
            url: '/ticket/aWqgT35s/new'
          };
          updatedAppState.push(tab);
        }
        break;
      case 'CLIENTS':
        tab = updatedAppState.find((el) => el.id === 'create-client');
        if (!tab) {
          tab = {
            id: 'create-client',
            content: getTabTemplate({ module: 'CLIENT_CREATION' }),
            module: 'CLIENT_CREATION',
            tabId: 'create-client',
            state: {},
            data: {},
            url: '/client/B604yRELWW/new'
          };
          updatedAppState.push(tab);
        }
        break;
      case 'PROJECTS':
        tab = updatedAppState.find((el) => el.id === 'create-project');
        if (!tab) {
          tab = {
            id: 'create-project',
            content: getTabTemplate({
              module: ALL_MODULES.projectCreation,
              data: { title: 'New Project' }
            }),
            module: ALL_MODULES.projectCreation,
            tabId: 'create-project',
            state: {},
            data: {},
            url: '/project/B604yRELWW/new'
          };
          updatedAppState.push(tab);
        }
        break;
      case 'NEW_CONTRACT_TEMPLATE':
        tab = updatedAppState.find((el) => el.id === 'new-contract-template');
        if (!tab) {
          tab = {
            id: 'new-contract-template',
            content: getTabTemplate({ module: 'NEW_CONTRACT_TEMPLATE' }),
            module: 'NEW_CONTRACT_TEMPLATE',
            tabId: 'new-contract-template',
            state: {},
            data: {},
            url: '/contracttemplate/H2Es51Am/new'
          };
          updatedAppState.push(tab);
        }
        break;
      case 'REPORTS':
        tab = updatedAppState.find((el) => el.id === 'reports-charts');
        if (!tab) {
          tab = {
            id: 'reports-charts',
            content: getTabTemplate({
              module: 'REPORTS_CHARTS_HOME',
              data: { title: 'New Dashboard' }
            }),
            module: 'REPORTS_CHARTS_HOME',
            tabId: 11,
            state: {},
            data: {},
            url: '/report/B604yRELWW/new'
          };
          updatedAppState.push(tab);
        } else {
          const tabIdx = updatedAppState.findIndex(
            (el) => el.id === 'reports-charts'
          );
          tab = {
            id: 'reports-charts',
            content: getTabTemplate({
              module: 'REPORTS_CHARTS_HOME',
              data: { title: 'Reports & Charts' }
            }),
            module: 'REPORTS_CHARTS_HOME',
            tabId: 11,
            state: {},
            data: {},
            url: '/report/B604yRELWW/new'
          };
          updatedAppState[tabIdx] = tab;
        }
        break;
      case 'CHARTS':
        const tabIdx = updatedAppState.findIndex(
          (el) => el.id === 'reports-charts'
        );
        tab = {
          id: 'reports-charts',
          content: getTabTemplate({
            module: 'REPORTS_CHARTS_HOME',
            data: {
              title: getTranslatedText(intl, 'reports.dashboard.title')
            }
          }),
          accessibilityLabel: 'Client tab',
          module: 'REPORTS_CHARTS_HOME',
          tabId: 11,
          state: {
            openModal: true
          },
          data: {},
          url: '/charts/2001/All Charts'
        };
        if (tabIdx === -1) {
          updatedAppState.push(tab);
        } else {
          updatedAppState[tabIdx] = tab;
        }
        break;
      case 'SCRIPTS':
        tab = updatedAppState.find((el) => el.id === 'create-script');
        if (!tab) {
          tab = {
            id: 'create-script',
            content: getTabTemplate({
              module: 'CREATE_SCRIPT',
              data: { title: 'New Script' }
            }),
            module: 'CREATE_SCRIPT',
            tabId: 'create-script',
            state: {},
            data: {},
            url: '/rmm/script/TxMcMMvvx/create'
          };
          updatedAppState.push(tab);
        }
        break;
      case 'ITDOC':
        tab = updatedAppState.find(
          (el) => el.id === 'create-non-monitored-asset'
        );
        if (!tab) {
          tab = {
            id: 'create-non-monitored-asset',
            content: getTabTemplate({
              module: 'CREATE_NON_MONITORED_ASSET_FORM',
              data: { title: 'Create IT Documentation' }
            }),
            module: 'CREATE_NON_MONITORED_ASSET_FORM',
            tabId: 'create-non-monitored-asset',
            state: {},
            data: {},
            url: '/non-monitored-asset-form/create'
          };
          updatedAppState.push(tab);
        }
        break;
      case 'MAIL_BOX':
        tab = updatedAppState.find((el) => el.id === 'create-email');
        if (!tab) {
          tab = {
            id: 'create-email',
            content: getTabTemplate({
              module: TAB_PAGES.mailbox,
              data: { title: 'New email' }
            }),
            module: TAB_PAGES.mailbox,
            tabId: 'create-email',
            state: {},
            data: {},
            url: '/mail/create'
          };
          updatedAppState.push(tab);
        }
        break;
      case 'NEW_INVOICE':
        tab = updatedAppState.find((el) => el.id === 'create-invoice');
        if (!tab) {
          tab = {
            id: 'create-invoice',
            content: getTabTemplate({
              module: TAB_PAGES.newInvoice,
              data: { title: 'New invoice' }
            }),
            module: TAB_PAGES.newInvoice,
            tabId: 'create-invoice',
            state: {},
            data: {},
            url: '/invoice/create'
          };
          updatedAppState.push(tab);
        }
        break;
      case 'NEW_QUOTE':
        tab = updatedAppState.find((el) => el.id === 'create-quote');
        if (!tab) {
          tab = {
            id: 'create-quote',
            content: getTabTemplate({
              module: TAB_PAGES.newQuote,
              data: {
                title: getTranslatedText(intl, 'app.create.quote.tabTitle')
              }
            }),
            module: TAB_PAGES.newQuote,
            tabId: 'create-quote',
            state: {},
            data: {},
            url: '/quote/create'
          };
          updatedAppState.push(tab);
        }
        break;
      default:
        break;
    }
    homeContext.updateUserAppState({
      ...currentAppState,
      appState: updatedAppState,
      activeTabIndex: updatedAppState.findIndex((el) => el.id === tab.id)
    });
    homeContext.closeCreateNewOverlay(true);
    setTimeout(() => {
      homeContext.switchTabFocus(tab);
    }, 200);
  };
  let authorizedModules = [];
  const reference = user?.role?.roleFeatureList || [];
  // const isTicketAuthorised = isAuthorised(reference, 'tickets.add');
  // const isClientAuthorised = isAuthorised(reference, 'client.add');
  // const isContractTemplateAuthorised = isAuthorised(
  //   reference,
  //   'contractTemplate.add'
  // );
  // const isReportsAuthorised =
  //   isAuthorised(reference, 'report.add') && flags?.reports;
  // const isChartsAuthorised =
  //   isAuthorised(reference, 'report.add') && flags?.charts;

  // const isProjectAuthorised =
  //   isAuthorised(reference, 'project.add') && flags?.projectManagement;

  const myWorkList = [
    {
      name: 'TICKET',
      label: 'app.modules.workspace.ticket',
      icon: <Ticket />,
      authorisation: 'tickets'
    },
    {
      name: 'PROJECTS',
      label: 'app.modules.workspace.project',
      icon: <Project />,
      ldFlag: 'projectManagement',
      authorisation: 'project'
    }
  ];

  const assetList = [
    {
      name: 'SCRIPTS',
      label: 'app.modules.asset.script',
      icon: <Script />
    },
    {
      name: 'ITDOC',
      label: 'asset.sidebar.ITdoc',
      icon: <ItDocumantation />,
      ldFlag: 'itDocumentation',
      authorisation: 'itDocumentationCategory'
    }
  ];

  const clientList = [
    {
      name: 'NEW_CONTRACT_TEMPLATE',
      label: 'app.modules.workspace.contractTemplate',
      icon: <ContractTemplate />,
      authorisation: 'contractTemplate'
    },
    {
      name: 'CLIENTS',
      label: 'client.mainpage.header',
      icon: <Clients />,
      authorisation: 'client'
    },
    {
      name: 'MAIL_BOX',
      label: 'app.create.newEmail.title',
      icon: <ModuleLogo image="mailbox.svg" />,
      authorisation: 'clientConversation',
      operation: 'add'
    },
    {
      name: 'NEW_INVOICE',
      label: 'app.create.invoice.title',
      icon: <Invoice />,
      authorisation: 'invoice'
    },
    {
      name: 'NEW_QUOTE',
      label: 'app.create.quote.title',
      icon: <Invoice />,
      ldFlag: 'quote',
      authorisation: 'invoice' // TODO-QUOTE: Change to quote
    }
  ];
  const reportsList = [
    {
      name: 'REPORTS',
      label: 'reports.dashboard.title',
      icon: <Reports />,
      ldFlag: 'reports',
      authorisation: 'report'
    },
    {
      name: 'CHARTS',
      label: 'app.modules.widgets.title',
      icon: <Charts />,
      ldFlag: 'charts',
      authorisation: 'report'
    }
  ];

  const authorisedWorkList = myWorkList.filter((el) => {
    if (!el.authorisation) return true;
    const isFeatureAuthorised = el.ldFlag
      ? isAuthorised(reference, `${el.authorisation}.add`) && flags[el.ldFlag]
      : isAuthorised(reference, `${el.authorisation}.add`);
    return isFeatureAuthorised;
  });

  const authorisedReportsAndCharts = reportsList.filter((el) => {
    if (!el.authorisation) return true;
    const isFeatureAuthorised = el.ldFlag
      ? isAuthorised(reference, `${el.authorisation}.add`) && flags[el.ldFlag]
      : isAuthorised(reference, `${el.authorisation}.add`);
    return isFeatureAuthorised;
  });

  const authorisedClients = clientList.filter((el) => {
    if (!el.authorisation) return true;
    const isFeatureAuthorised = el.ldFlag
      ? isAuthorised(
          reference,
          `${el.authorisation}.${el.operation ? el.operation : 'add'}`
        ) && flags[el.ldFlag]
      : isAuthorised(
          reference,
          `${el.authorisation}.${el.authorisation}.${
            el.operation ? el.operation : 'add'
          }`
        );
    return isFeatureAuthorised;
  });

  const authorisedAssetManagement = assetList.filter((el) => {
    if (!el.ldFlag) return true;
    const isFeatureAuthorised = el.ldFlag
      ? isAuthorised(
          reference,
          `${el.authorisation}.${el.operation ? el.operation : 'add'}`
        ) && flags[el.ldFlag]
      : isAuthorised(
          reference,
          `${el.authorisation}.${el.authorisation}.${
            el.operation ? el.operation : 'add'
          }`
        );
    return isFeatureAuthorised;
  });

  // if (isTicketAuthorised) {
  //   authorizedModules.push({
  //     name: 'TICKET',
  //     label: 'TICKET',
  //     icon: <Ticket />,
  //     group: 'New work'
  //   });
  // }
  // if (isClientAuthorised) {
  //   authorizedModules.push({
  //     name: 'CLIENTS',
  //     label: 'CLIENT',
  //     icon: <Clients />,
  //     group: 'Client'
  //   });
  // }
  // if (isProjectAuthorised) {
  //   authorizedModules.push({
  //     name: 'PROJECTS',
  //     label: 'PROJECT',
  //     icon: <Project />,
  //     group: 'New work'
  //   });
  // }
  // if (isReportsAuthorised) {
  //   authorizedModules.push({
  //     name: 'REPORTS',
  //     label: 'app.modules.reports.title',
  //     icon: <Reports />,
  //     group: 'Dashboard & Reports'
  //   });
  // }
  // if (isChartsAuthorised) {
  //   authorizedModules.push({
  //     name: 'CHARTS',
  //     label: 'app.modules.charts.title',
  //     icon: <Charts />
  //   });
  // }
  // if (flags.newContracts && isContractTemplateAuthorised) {
  //   authorizedModules.push({
  //     name: 'NEW_CONTRACT_TEMPLATE',
  //     label: 'CONTRACT TEMPLATE',
  //     icon: <Clients />,
  //     group: 'Client'
  //   });
  // }

  return (
    <HomeScreen browser={browser} className="sops-overlay-wrap">
      <Header className="sops-overlay-header">
        <Greeting className="sops-greating-text sops-row-wrap">
          <FormattedMessage id="common.create" />
        </Greeting>
        <Actions>
          <Button
            onClick={() => {
              homeContext.closeCreateNewOverlay(true);
            }}
            plain
          >
            <Close />
          </Button>
        </Actions>
      </Header>
      <SopsModuleWrap className="sops-module-wrap-height">
        <SopsInnerWrap className="sops-module-wrap">
          <div className="sops-row-wrap sops-create-model">
            {authorisedWorkList?.length > 0 && (
              <div className="sops-box-wrap">
                <ModuleSub className="sops-sub-head">
                  <FormattedMessage id="app.create.newWork" />
                </ModuleSub>

                <Modules className="sops-sec-wrap">
                  {authorisedWorkList.map((el, i) => {
                    return (
                      <Module
                        onClick={handleCreation.bind(this, el)}
                        module={el}
                        index={i}
                      />
                    );
                  })}
                </Modules>
              </div>
            )}

            <div className="sops-box-wrap">
              {authorisedAssetManagement?.length > 0 && (
                <ModuleSub className="sops-sub-head">
                  <FormattedMessage id="app.modules.asset.asset" />
                </ModuleSub>
              )}
              <Modules className="sops-sec-wrap">
                {authorisedAssetManagement.map((el, i) => {
                  return (
                    <Module
                      onClick={handleCreation.bind(this, el)}
                      module={el}
                      index={i}
                    />
                  );
                })}
              </Modules>
            </div>
          </div>

          <div className="sops-row-wrap sops-create-model">
            {authorisedClients?.length > 0 && (
              <div className="sops-box-wrap">
                <ModuleSub className="sops-sub-head">
                  <FormattedMessage id="app.modules.client.client" />
                </ModuleSub>

                <Modules className="sops-sec-wrap">
                  {authorisedClients.map((el, i) => {
                    return (
                      <Module
                        onClick={handleCreation.bind(this, el)}
                        module={el}
                        index={i}
                      />
                    );
                  })}
                </Modules>
              </div>
            )}
            <div className="sops-box-wrap">
              {authorisedReportsAndCharts?.length > 0 && (
                <ModuleSub className="sops-sub-head">
                  <FormattedMessage id="app.modules.reportscharts.title" />
                </ModuleSub>
              )}
              <Modules className="sops-sec-wrap">
                {authorisedReportsAndCharts.map((el, i) => {
                  return (
                    <Module
                      onClick={handleCreation.bind(this, el)}
                      module={el}
                      index={i}
                    />
                  );
                })}
              </Modules>
            </div>
          </div>
        </SopsInnerWrap>
      </SopsModuleWrap>
    </HomeScreen>
  );
}

const Header = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 40px;
  padding-left: 40px;
  padding-right: 40px;
`;

const Actions = styled.div`
  margin-left: auto;
  display: flex;
  button {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #ffffff33;
    span,
    span svg {
      width: 20px;
      height: 20px;
    }
    &:hover {
      background-color: #ffffff;
    }
  }
`;

const HomeScreen = styled.div`
  background: ${(props) =>
    props.browser === 'Mozilla Firefox'
      ? '#ececec'
      : 'radial-gradient(115.28% 115.28% at 26.48% -11.94%, rgba(252, 252, 255, 0.8) 0%,rgba(125, 125, 155, 0.04) 100%)'};
  backdrop-filter: blur(80px);
  padding: 20px 0px;
  height: 100vh;
  .module-logo {
    height: 56px;
    width: 64px;
  }
`;
const Greeting = styled.div`
  line-height: 63px;
  font-weight: normal;
  font-size: 30px;
  margin-bottom: 20px;
  padding: 0 10px;
  display: flex;
  flex-grow: 1;
`;
const Modules = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 10px 10px 40px;
  gap: 20px;
`;
const SopsModuleWrap = styled.div`
  width: 100%;
  overflow-y: auto;
  height: calc(100vh - 160px);
`;

const SopsInnerWrap = styled.div`
  width: 1060px;
  margin: 0 auto;
`;

const ModuleSub = styled.div`
  line-height: 30px;
  font-weight: 400;
  font-size: 22px;
  padding: 0 10px;
`;

export default injectIntl(withRouter(withLDConsumer()(GlobalCreatePage)));
